import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

try {
  const swiperEls = document.querySelectorAll('.swiper');

  const defaultSwiperConfig = {
    modules: [Navigation, Pagination, Scrollbar, Autoplay],
    spaceBetween: 24,
    slidesPerView: 'auto',
    loop: false,
  };

  swiperEls.forEach((swiperEl) => {
    let swiperParentEl = swiperEl.closest('.swiper-container') || swiperEl;
    let swiperConfig = defaultSwiperConfig;

    const swiperBtnPrevDefaultEl = swiperParentEl.querySelector(
      '.swiper-button-prev'
    );
    const swiperBtnNextDefaultEl = swiperParentEl.querySelector(
      '.swiper-button-next'
    );
    const swiperPaginationDefaultEl =
      swiperParentEl.querySelector('.swiper-pagination');
    const swiperScrollbarDefaultEl =
      swiperParentEl.querySelector('.swiper-scrollbar');

    if (swiperBtnPrevDefaultEl && swiperBtnNextDefaultEl) {
      swiperConfig = {
        ...swiperConfig,
        navigation: {
          prevEl: swiperBtnPrevDefaultEl,
          nextEl: swiperBtnNextDefaultEl,
        },
      };
    }

    if (swiperPaginationDefaultEl) {
      swiperConfig = {
        ...swiperConfig,
        pagination: {
          el: swiperPaginationDefaultEl,
        },
      };
    }

    if (swiperScrollbarDefaultEl) {
      swiperConfig = {
        ...swiperConfig,
        scrollbar: {
          el: swiperScrollbarDefaultEl,
        },
      };
    }

    if (swiperEl.hasAttribute('data-swiper-config')) {
      const elementSwiperConfig = JSON.parse(
        swiperEl.getAttribute('data-swiper-config')
      );

      swiperConfig = {
        ...swiperConfig,
        ...elementSwiperConfig,
      };
    }

    new Swiper(swiperEl, swiperConfig);
  });
} catch (error) {
  console.error(error);
}
